import React from 'react';
import { useClientSelectListQuery } from 'api';
import { Select } from 'components';
import { FMGSelectProps } from 'components/antd/select';
import { useAccessControl } from '../accessControl/useAccessControl';
import { PERMISSIONS } from '../../../constants/permissions';

export const ClientSelect: React.FC<FMGSelectProps> = React.memo((props) => {
  const { data = [] } = useClientSelectListQuery();
  const { hasAccess } = useAccessControl();
  return (
    <Select
      options={hasAccess(PERMISSIONS.clients.client.read) ? data : []}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
